(angular => {
  "use strict";

  angular.module("Auth").controller("Auth.LoginCtrl", [
    "$location",
    "Toast",
    "Loader",
    "LoginService",
    "AuthService",
    "ParticipantService",
    LoginCtrl
  ]);

  function LoginCtrl($location, Toast, Loader, loginService, authService, participantService) {
    this.cpf = null;

    const token = $location.search().t;
    const page = $location.search().p;

    if (token) {
      $location.search({});
      authService.setToken(token);
    }

    if (authService.isLoggedIn()) {
      $location.path(page || "/dashboard");
      return;
    }

    this.login = () => {
      Loader.add(loginService.doLogin(this.cpf)).then(() => {
        participantService.getMarketingActivity().then(participant => {
          const today = moment(new Date());
          if (today.isAfter(participant.event.end_date, 'day')) {
            $location.path("/certificado");
            return;
          }

          if(participant.event.marketing_activity && participant.activities && participant.status === 'accepted') {
            $location.path("/findRetailer");
            return;
          }
          $location.path("/dashboard");
        });
      }).catch((err) => {
        if (err.status === 404 || err.status === 400) {
          return Toast.show("Dados inválidos", "error");
        }
        Toast.show((err.data || err).message || "Falha ao efetuar login", "error");
      });
    };

  }

})(angular);
